// sortByField and unique
export function sortByField<T>(data: T[], field: keyof T, unique = false, descending = false): T[] {
	const r = descending ? -1 : 1;  // used to reverse (-1, 0, +1) ordering
	const sorted = data
		.sort((a, b) => r * ((a[field] < b[field]) ? -1 : ((a[field] > b[field]) ? 1 : 0)));  // sort
	return !unique ? sorted :
		sorted.filter((v, i, A) => i === 0 || v[field] !== A[i - 1][field]);  // unique
}

// Generic types
export type HashMap<T = string> = { [key: string]: T };
export type NumHashMap<T = string> = { [key: number]: T };
export type KeyHashMap<K, T = string> = Partial<{ [P in keyof K]: T }>;
export type EnumHashMap<E extends string, T = string> = { [P in E]?: T };


// formatting
export function formatDate(date: Date | string, omitYear = false) {
	const d = typeof date === 'string' ? new Date(date) : date;
	const t = d.toDateString();
	return omitYear ? t.substr(0, t.length - 5) : t;
}

export function formatDateLong(date: Date | string) {
	const d = typeof date === 'string' ? new Date(date) : date;
	const month = d.toLocaleString('en-US', { month: 'long' });
	return `${d.getDate()} ${month} ${d.getFullYear()}`;
}

export function formatHour(date: Date | string) {
	const d = typeof date === 'string' ? new Date(date) : date;
	const t = d.toTimeString();
	return t.substr(0, 5);
}

export function formatTimestamp(date: Date | string) {
	const d = typeof date === 'string' ? new Date(date) : date;
	const a = d.toDateString();
	const b = d.toTimeString();
	return `${a} at ${b.substr(0, 8)}`;
}
